// extracted by mini-css-extract-plugin
module.exports = {"content_list":"content_list--2gqytsD","chip_item":"chip_item-c6g-eZ80"};